import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getModuleData } from '../redux/selectors/modules';
import { updateModule } from '../redux/actions/modules';
export function useModuleData(moduleId) {
    const dispatch = useDispatch();
    const moduleData = useSelector((state)=>getModuleData(state, moduleId));
    const updateModuleData = useCallback((data, replace = false)=>dispatch(updateModule({
            id: moduleId,
            moduleData: replace ? data : _object_spread({}, moduleData, data)
        })), [
        dispatch,
        moduleId,
        moduleData
    ]);
    return {
        moduleData,
        updateModuleData
    };
}
export default useModuleData;
